import Layout from '@/components/layout/Layout.vue'
import CreateForm from '@/views/sys/media-account/create/Create.vue'
import SpiSubscriptionForm from '@/views/sys/media-account/spi-subscription/SpiSubscription.vue'
import { getMediaAccounts, deleteMediaAccounts } from '@/api/media-account'
import { getMedias, getMediaTypes } from '@/api/constant'
import api from '@/config/api'
import { getCorporations, getDeveloperAccounts } from '@/api/open'

export default {
    name: 'media_accounts',
    components: {
        Layout,
        CreateForm,
        SpiSubscriptionForm
    },
    data() {
        return {
            data: [],
            loading: false,
            medias: [],
            selectedRowKeys: [],
            columns: [
                { width: 60,  type: 'checkbox' ,fixed: 'left'},
                { minWidth: 100, title: 'ID', field: 'id' },
                { minWidth: 200,title: '开发者账号ID', field: 'out_id' },
                { minWidth: 200,title: '媒体名称', field: 'media', formatter: item => {
                        return this.$helper.getItemName(this.medias, item.row.media) || '-'
                    }
                },
                { minWidth: 140,title: '开放平台类型', field: 'open_platform_type', formatter: item => {
                        // 未设置（null）时不展示，避免把空值伪造成「磁力引擎」
                        const name = this.$helper.getItemName(this.openPlatformTypes, item.row.open_platform_type)
                        return name || ''
                    }
                },
                { minWidth: 200,title: '代理商', field: 'media_type', formatter: item => {
                        return this.$helper.getItemName(this.mediaTypes, item.row.media_type) || '-'
                    }
                },
                { minWidth: 200,title: '账号名称', field: 'name' },
                { minWidth: 100,title: '广告主数量', field: 'advertiser_num' },
                { minWidth: 120,title: 'SPI订阅数量', field: 'spi_subscription_num' },
                { minWidth: 500, title: '操作', field: 'action', slots: { default: 'action' } }
            ],
            model: {},
            showForm: false,
            showSpiSubscription: false,
            spiSubscriptionRecord: {},
            queryParam: {},
            tableGrid: this.getTableGrid(),
            corporations: [],
            developerAccounts: [],
            super_or_main: false,
            mediaTypes: [],
            payTypes: [{id:1,name:'付费'},{id:2,name:'免费'}],
            businessTypes: [{id:1,name:'快手分销'},{id:2,name:'快手番茄代投'}],
            // 开放平台类型 1-磁力引擎 2-短剧经营者
            openPlatformTypes: [{id:1,name:'磁力引擎'},{id:2,name:'短剧经营者'}],
        }
    },
    mounted() {
        this.tableGrid.columns = this.columns
        getCorporations().then(res=>{ this.corporations = res.data.list || {} })
        getDeveloperAccounts().then(res=>{ 
            this.developerAccounts = res.data.list || {} 
            this.super_or_main = res.data.super_or_main || false 
            // 根据 super_or_main 动态控制列显示
            if (this.super_or_main) {
                // 插入“开发者账号”列
                this.columns.splice(2, 0, {
                    minWidth: 260,
                    title: '开发者账号',
                    field: 'developer_account_id',
                    formatter: item => {
                        return this.$helper.getItemName(this.developerAccounts, item.row.developer_account_id) || '-'
                    }
                })
            }
            this.tableGrid.columns = this.columns
        })
        this.getData()
        getMedias().then(res => {
            this.medias = res.data.list || []
        }).finally(() => {
            this.getData()
        })
        getMediaTypes().then(res => {this.mediaTypes = res.data.list || []})
    },
    methods: {
        getTableGrid() {
            let grid = this.$helper.tableGrid('mediaAccount')
            grid.size = 'medium'
            grid.border = 'inner'
            return grid
        },
        handleRowChange(result) {
            this.selectedRowKeys = result.records.flatMap((item) => {
                return item.id
            })
        },
        create(record) {
            this.model = record.id ? Object.assign({}, record) :{
                enabled: true,
                // 新建默认磁力引擎，短剧经营者账号需手动选择
                open_platform_type: 1,
                settings: {}
            }
            this.showForm = true
        },
        destroy(record) {
            const del = ids => {
                deleteMediaAccounts(ids).then(res => {
                    this.$message.destroy()
                    if (res && res.code === 0) {
                        this.$message.success('删除成功')
                        this.refresh()
                    }
                })
            }
            if (!record) {
                return this.$confirm({
                    title: '操作提示',
                    centered: true,
                    content: () => <div
                        style="color:red;">确定要删除选中的 {this.selectedRowKeys.length} 条数据吗?</div>,
                    onOk: () => {
                        del(this.selectedRowKeys)
                    }
                })
            }
            del([record.id])
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys
        },
        getData() {
            this.tableGrid.loading = true
            const json = Object.assign({}, this.queryParam, {
                page: this.tableGrid.pagerConfig.currentPage,
                page_size: this.tableGrid.pagerConfig.pageSize
            })
            getMediaAccounts(json).then(res => {
                this.tableGrid.pagerConfig.total = res.data.total
                this.tableGrid.loading = false
                this.tableGrid.data = res.data.list
              
                this.data = res.data.list
            }).catch(() => {
                this.tableGrid.loading = false
            })
        },
        copyUrl(record, type = 'callback') {
            const mediaKey = this.$helper.getMediaKey(record.media)
            let url = ''
            if (type === 'spi') {
                url = `${api.baseUrl}/api/callback/${mediaKey}/${record.id}/spi`
            } else if (type === 'new') {
                url = `${api.baseUrl}/api/callback/${mediaKey}_new/${record.id}`
            } else {
                url = `${api.baseUrl}/api/callback/${mediaKey}/${record.id}`
            }
            this.$helper.clipboard(url)
            this.$message.success('复制成功')
        },
        openSpiSubscription(record) {
            this.spiSubscriptionRecord = Object.assign({}, record)
            this.showSpiSubscription = true
        },
        refresh() {
            this.getData()
        },
        search() {
            this.tableGrid.pagerConfig.currentPage = 1
            this.getData()
        },
        resetSearch() {
            this.queryParam = {}
            this.getData()
        },
        accessTo(route) {
            return this.$helper.accessTo('MediaAccountController', route)
        },
        handlePageChange(pager) {
            this.tableGrid.pagerConfig.currentPage = pager.currentPage
            this.tableGrid.pagerConfig.pageSize = pager.pageSize
            this.getData()
        },
        handleSortChange(data) {
            this.queryParam.sort_field = data.order ? data.field : null
            this.queryParam.sort_type = data.order
            this.getData()
        },
    }
}
